import { Component, Input } from '@angular/core';
import { LeadComposerChangesModel, LeadsHistory } from '../../../../../models/leads/leads.model';

@Component({
  selector: 'fi-composer-changes-comments',
  templateUrl: './composer-changes.component.html',
  styleUrls: ['./composer-changes.component.scss'],
  standalone: false,
})
export class ComposerChangesComponent {

  @Input() composerChanges: LeadComposerChangesModel[];
  @Input() history: LeadsHistory;


  constructor() {

  }

}
